import { z } from "zod";
import { createAuditLogSchema, updateAuditLogSchema } from "@fysaro/schemas";

export const AUDIT_ENTITIES = {
  ADMIN: "Admin",
  AUTH: "Auth",
  AVAILABILITY: "Availability",
  AVAILABILITY_EXCEPTION: "AvailabilityException",
  BLOCKED_SLOT: "BlockedSlot",
  BOOKING: "Booking",
  PATIENT: "Patient",
  CLINIC: "Clinic",
  DASHBOARD: "Dashboard",
  INVITATION: "Invitation",
  PLAN: "Plan",
  ONBOARDING: "Onboarding",
  PASSWORD_RESET: "PasswordReset",
  PROFESSIONAL: "Professional",
  SERVICE: "Service",
  SERVICE_CATEGORY: "ServiceCategory",
  SPECIALTY: "Specialty",
  SUBSCRIPTION: "Subscription",
  UPLOAD: "Upload",
  USER: "User",
  SYSTEM: "System",
  CRON: "Cron",
} as const;

export const AUDIT_ACTIONS = {
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  DELETED: "DELETED",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  PASSWORD_RESET_REQUESTED: "PASSWORD_RESET_REQUESTED",
  PASSWORD_CHANGED: "PASSWORD_CHANGED",
  USER_DISABLED: "USER_DISABLED",
  USER_REACTIVATED: "USER_REACTIVATED",
  USER_ROLE_CHANGED: "USER_ROLE_CHANGED",
  USER_UPDATED: "USER_UPDATED",
  ROLE_ASSIGNED: "ROLE_ASSIGNED",
  BOOKING_CREATED: "BOOKING_CREATED",
  BOOKING_UPDATED: "BOOKING_UPDATED",
  BOOKING_CANCELLED: "BOOKING_CANCELLED",
  CLINIC_OWNER_REASSIGNED: "CLINIC_OWNER_REASSIGNED",
  INVITATION_SENT: "INVITATION_SENT",
  INVITATION_ACCEPTED: "INVITATION_ACCEPTED",
  ONBOARDING_STEP_UPDATED: "ONBOARDING_STEP_UPDATED",
  FILE_UPLOADED: "FILE_UPLOADED",
  SYSTEM_EVENT: "SYSTEM_EVENT",
  SETTINGS_UPDATED: "SETTINGS_UPDATED",
  ERROR: "ERROR",
  CRON_EXECUTED: "CRON_EXECUTED",
  CRON_ERROR: "CRON_ERROR",
} as const;

export type AuditEntity = (typeof AUDIT_ENTITIES)[keyof typeof AUDIT_ENTITIES];
export type AuditAction = (typeof AUDIT_ACTIONS)[keyof typeof AUDIT_ACTIONS];

export type CreateAuditLogInput = z.infer<typeof createAuditLogSchema>;
export type UpdateAuditLogInput = z.infer<typeof updateAuditLogSchema>;

//
// SEARCH
//
export interface LogSearchParams {
  //userId: string | null;
  page: number;
  pageSize: number;
  search?: string;
  action?: AuditAction | "ALL";
  entity: AuditEntity;
  dateFrom: string;
  dateTo: string;
}
